import React, { useState, useEffect } from "react";
import { Table as AntTable } from "antd";
import { TableProps } from "antd/lib/table";
import ExportTableButton, {
  IExportFieldButtonProps,
} from "./ExportTableButton";
import SearchTableInput, { ISearchTableInputProps } from "./SearchTableInput";
import { useMountedState } from "./hooks/isMounted";

export * from "./ExportTableButton";
export * from "./SearchTableInput";

export type IExportableTableProps = TableProps<any> & IExportFieldButtonProps;

export type ITableUtils = {
  /** Exportable Table */
  exportable?: boolean;
  /** Props object to customize export button */
  exportableProps?: IExportFieldButtonProps;
  /** Searchable Table */
  searchable?: boolean;
  /** Props object to customize export button */
  searchableProps?: ISearchTableInputProps;
  headerBackground?: string;
};

export type ITableProps<T> = TableProps<T> & ITableUtils;

export const Table: React.FC<ITableProps<any>> = ({
  exportable = false,
  exportableProps,
  searchable = false,
  searchableProps,
  headerBackground="#fff",
  dataSource,
  columns,
  ...otherProps
}) => {
  const isMounted = useMountedState();
  const isExportable = exportable || exportableProps;
  const isSearchable = searchable || searchableProps;
  const [searchDataSource, setSearchDataSource] = useState<any>(dataSource);

  useEffect(() => {
    if (isSearchable && isMounted()) {
      setSearchDataSource(dataSource);
    }
  }, [isSearchable, dataSource, isMounted]);

  return (
    <div>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignContent: "center",
          alignItems: "center",
          background: headerBackground
        }}
      >
        <span style={{ marginLeft: 10 }}>Total Found: {(dataSource !== null || dataSource !== undefined) ? dataSource?.length : 0}</span>
        {isExportable ? (
          <ExportTableButton
            dataSource={dataSource}
            columns={columns}
            {...exportableProps}
          />
        ) : null}
        {isSearchable ? (
          <SearchTableInput
            columns={columns}
            dataSource={dataSource}
            setDataSource={setSearchDataSource}
            {...searchableProps}
            inputProps={{
              style: {
                width: isExportable ? 250:250,
                margin: "10px 10px 10px 0",
                ...searchableProps?.inputProps?.style,
              },
              ...searchableProps?.inputProps,
            }}
          />
        ) : null}
      </div>
      <AntTable
        dataSource={isSearchable ? searchDataSource : dataSource}
        columns={columns}
        {...otherProps}
      />
    </div>
  );
};
